import React, {useState} from 'react'
import Footer from '../footer'
import EMICalculator from './EMICalculator'
import Header from './Headers'
import Howdoes from './work'

const GetStarted = (props) => {
    const [screen, setScreen] = useState('1')

    const screencahnge = (img) => {
        setScreen(img);
    }
    return (
        <div>
            <Header/>
            <section className="pdtb-20">
                <section className="breadcrumbs">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <h2>Get Started</h2>
                            <ol>
                                <li><a href="/">Home</a></li>
                                <li>Get Started</li>
                            </ol>
                        </div>
                    </div>
                </section>
            </section>

            <section className="app_work" id="app_work">
                <div className='container'>
                    <div className="section-titles">
                        <h3 className="heading_tow">DOWNLOAD OUR MOBILE APP</h3>
                    </div>
                    <div className="container">
                        <div className="row">
                            <h3 className="d-block d-md-none full-w text-center color_main fz-20">How the app works</h3>
                            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 col-xl-6">
                                <figure className="app_work_images">
                                    <img src={require(`../images/appwork_${screen}.png`)} alt=""/>
                                </figure>
                            </div>
                            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 col-xl-6">
                                <Howdoes mychanges={screencahnge}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="app_work" id="app_work">
                <div className='container'>
                    <EMICalculator/>
                </div>
            </section>
            <Footer/>
        </div>
    )
}

export default GetStarted



// WEBPACK FOOTER //
// ./src/components/GetStarted.js